import React from "react";

export function RateReviewIcon() {
  return (
    <svg
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1332_1139)">
        <path
          d="M45.8334 4.58301H9.16671C6.64587 4.58301 4.60629 6.64551 4.60629 9.16634L4.58337 50.4163L13.75 41.2497H45.8334C48.3542 41.2497 50.4167 39.1872 50.4167 36.6663V9.16634C50.4167 6.64551 48.3542 4.58301 45.8334 4.58301ZM45.8334 36.6663H11.848L10.4959 38.0184L9.16671 39.3476V9.16634H45.8334V36.6663ZM24.0625 32.083H41.25V27.4997H28.6459L24.0625 32.083ZM32.9084 18.6309C33.3667 18.1726 33.3667 17.4622 32.9084 17.0038L28.8521 12.9476C28.3938 12.4893 27.6834 12.4893 27.225 12.9476L13.75 26.4226V32.083H19.4105L32.9084 18.6309Z"
          fill="white"
          fillOpacity="0.3"
        />
      </g>
      <defs>
        <clipPath id="clip0_1332_1139">
          <rect width="55" height="55" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
